import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, createApp } from 'vue';
import { useRouter } from 'vue-router';

import Searchbar from '@components/header/Searchbar.vue';
import SearchbarMenuItem from '@components/header/SearchbarMenuItem.vue';

import * as utils from '@services/utils/common';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'SearchModal',
},
  __name: 'SearchModal',
  setup(__props) {



const router = useRouter();

const shown = ref(false);
const visible = ref(false);

// register modal
console.assert(!_m.modals.search, 'SearchModal created twice');
_m.modals.search = open;

// create right header button
const header = document.querySelector<HTMLDivElement>('.header-right, .header-end');
if (header && utils.uid) {
  const div = document.createElement('div');
  header.prepend(div);
  const headerApp = createApp(SearchbarMenuItem);
  try {
    headerApp.use(router);
  } catch {}
  headerApp.mount(div);

  // remove unified search button
  document.querySelector<HTMLDivElement>('.unified-search-menu')?.remove(); // 29+
  document.querySelector<HTMLDivElement>('.unified-search__button')?.remove(); // 28
  document.querySelector<HTMLDivElement>('.header-menu.unified-search')?.remove(); // 27
}

function open() {
  shown.value = true;
  setTimeout(() => (visible.value = true), 5);
}

function close($event?: any) {
  if (!$event || ($event.target as HTMLElement).matches('.search-overlay')) {
    visible.value = false;
    setTimeout(() => (shown.value = false), 160);
  }
}

return (_ctx: any,_cache: any) => {
  return (shown.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["search-overlay", { visible: visible.value }]),
        onClick: _withModifiers(close, ["stop"])
      }, [
        _createVNode(Searchbar, {
          "auto-focus": true,
          onSelect: close
        })
      ], 2))
    : _createCommentVNode("", true)
}
}

})